import OfficerReducer from "../reducers/OfficerReducer";
import BaseAction from "./BaseAction";

class OfficerFormAction extends BaseAction {
  setLoadingOfficers = async (value) =>
    await this.dispatch({ loadingOfficers: value });

  setLoadingPoliceId = async (value) =>
    await this.dispatch({ loadingPoliceId: value });

  editOfficer = async (value) => {
    await this.dispatch({ officer: value });
  };
}

const action = new OfficerFormAction(OfficerReducer);

export default action;
